/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit GreyfinchBird/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function GreyfinchBird({
  children,
  viewPath = "/DesignSystem/Svgs/GreyfinchBird",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 200,
  height = 131.3,
  fill = "#00CE7C"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="GreyfinchBird.Svg"
  data-view-path={viewPath}
 viewBox="0 0 200 131.3"
 style={{'--as-1-ZBSIaB': alignSelf,'--mt-2-ZBSIaB': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZBSIaB': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZBSIaB': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZBSIaB': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZBSIaB': opacity,'--w-7-ZBSIaB': typeof width === 'number' ? `${width}px` : width,'--h-8-ZBSIaB': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="GreyfinchBird.SvgPath"
  data-view-path={viewPath}
 d="M119.2 58.9c5.6-.1 9.5-5.9 22.3-9C154 33.6 156.9 8.3 156.2 6.6c-.7-1.7-47.5 19.2-56.6 42.5-1 2.4 15.5 9.9 19.6 9.8zM138.8 109.9l.1-.1-.2.2.1-.1z"
 style={{'--f-9-ZBSIaB': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="GreyfinchBird.SvgPath:1"
  data-view-path={viewPath}
 d="M125.4 60.7c-1.6 1-3.2 2.1-5 2.3-1.8.2-3.9-.6-5.9-1.5-36.6-15.2-66.6-36.1-74.9-43.4C31.3 10.7 5 67.5 53.2 87.7c11.6 4.8 16.8 8.5 14.8 10-5.4 4-48.6 16.2-59.3 16.6-3.3.1 2.4 5.7 5.3 5.9 3 .1 22.6-4.2 40.6-5 8.2-.4 20.7 2 25.6 3.6 18 5.9 37.8-3.3 55.6-18.4S154 84.5 159 80.5c24.1-19 34.1-11.1 35.4-14 1.2-3-30.9-29-69-5.8z"
 style={{'--f-9-ZBSIaB': fill}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}